import React from "react";

import styles from "./Footer.module.scss";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import { Paths } from "shared/types/navigation";
import Logo from "shared/icons/Logo/Logo";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2} className={styles.footer_links}>
          <Link to={Paths.termOfUse}>Terms of use</Link>
        </Grid>

        <Grid item xs={12} md={2} className={styles.footer_links}>
          <Link to={Paths.privacyPolicy}>Privacy Policy</Link>
        </Grid>
      </Grid>

      <Divider style={{ width: "100%" }} />

      <div className={styles.footer_copyRight}>
        <Logo />

        <div>
          <p>&copy; 2021 Thu Nghiem</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
